module.exports = __webpack_public_path__ + "assets/img/8ae4efd49cbf323086a1707a28eb2f72.png";